export default {
  state: {
    showLoaderCount: 0,
    sidebarVisible: false,
    datetimeDialogDisplayed: false,
    notificationBarDismessed: false,
  },

  mutations: {
    changeShowLoader(state, payload) {
      if (payload === true) {
        state.showLoaderCount += 1;
      } else {
        // Clamp at 0 so an unmatched "false" can't drive the count negative,
        // which would otherwise swallow a later legitimate loader.
        state.showLoaderCount = Math.max(0, state.showLoaderCount - 1);
      }
    },
    // Force the loader off regardless of the current count. Called on route
    // changes so a counter leaked by a failed request on one page can never
    // keep the global loader stuck on the next one.
    resetLoader(state) {
      state.showLoaderCount = 0;
    },
    changeDatetimeDialogDisplayed(state, payload) {
      state.datetimeDialogDisplayed = payload;
    },
    changeNotificationBarDismessedStatus(state, payload) {
      state.notificationBarDismessed = payload;
    },
  },
};
